"use client";

import { Heart } from "lucide-react";

interface MatchScoreBadgeProps {
  score: number;
  className?: string;
}

/**
 * Badge de compatibilidade (0–100%) exibido sobre o card de imóvel no matching.
 * Faixas: ≥90 verde, 70–89 azul, <70 cinza.
 */
export function matchScoreColors(score: number): { bg: string; fg: string } {
  if (score >= 90) return { bg: "#DCFCE7", fg: "#15803D" }; // verde
  if (score >= 70) return { bg: "#DBEAFE", fg: "#1D4ED8" }; // azul
  return { bg: "#F3F4F6", fg: "#4B5563" }; // cinza
}

export default function MatchScoreBadge({ score, className = "" }: MatchScoreBadgeProps) {
  const { bg, fg } = matchScoreColors(score);
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-bold shadow-sm backdrop-blur-sm ${className}`}
      style={{ backgroundColor: bg, color: fg }}
      aria-label={`Compatibilidade de ${score}%`}
    >
      <Heart className="h-3 w-3 fill-current" aria-hidden="true" />
      {score}%
    </span>
  );
}
